import { render, staticRenderFns } from "./Watched.vue?vue&type=template&id=5358aa50&scoped=true&"
import script from "./Watched.vue?vue&type=script&lang=js&"
export * from "./Watched.vue?vue&type=script&lang=js&"
import style0 from "./Watched.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Watched.vue?vue&type=style&index=1&id=5358aa50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358aa50",
  null
  
)

export default component.exports